import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import MainRouter from './MainRouter';
import store from "../src/state/store";

ReactDOM.render(
  <Provider store={store}>
    <ChakraProvider>
      <MainRouter />
    </ChakraProvider>
  </Provider>,
  document.getElementById('root')
);
